import Dialog from '@/components/dialog.vue';
<template>
  <Dialog ref="dialog" width="500px" title="模板驳回">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="驳回原因" prop="reasons">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4}"
          placeholder="请输入驳回原因"
          v-model="ruleForm.reasons">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" :loading="loading" @click="submitForm('ruleForm')">提交</el-button>
      </el-form-item>
    </el-form>
    
  </Dialog>
</template>

<script>
import Dialog from '@/components/dialog.vue'
export default {
  components: {
    Dialog
  },
  props: {
    templateId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      ruleForm: {
        reasons: ''
      },
      rules: {
        reasons: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' }
        ],
      },
      loading: false
    }
  },
  methods: {
    open() {
      this.$refs.dialog.open();
    },
    close() {
      this.$refs.dialog.close();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$api.templateAuditReject({
            templateId: this.templateId,
            remark: this.ruleForm.reasons
          }).then(res => {
            if (res) {
              this.close();
              this.$emit('submited');
            }
          }).finally(() => {
            this.loading = false;
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<style>

</style>